import WorksImportRequest from "../ws/WorksImportRequest";

export const WORKS_IMPORT_UPDATE = 'works-import-update';
export const WORKS_IMPORT_LOADING = 'works-import-loading';
export const WORKS_IMPORT_ERROR = 'works-import-error';
export const WORK_IMPORTED_UPDATE = 'work-imported-update';

export const getWorksToImport = (search = '') => (dispatch) => {

  new WorksImportRequest(1, search)
    .onPreExecution(() => {
      dispatch({ type: WORKS_IMPORT_LOADING, payload: true });
    })
    .onSuccess(data => {
      // Enviamos los datos a redux
      dispatch({
        type: WORKS_IMPORT_UPDATE,
        payload: data,
      });
    })
    .onFail(error => {
      dispatch({ type: WORKS_IMPORT_ERROR, payload: error });
    })
    .onPostExecution(() => {
      dispatch({ type: WORKS_IMPORT_LOADING, payload: false });
    })
    .execute();
};

export const importWork = (work) => (dispatch) => {
  dispatch({ type: WORK_IMPORTED_UPDATE, payload: work });
};





// WEBPACK FOOTER //
// ./src/app/works/actions/workImportActions.js